var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    {
      scopedSlots: _vm._u([
        {
          key: "card-footer",
          fn: function () {
            return [
              _c("mortgage-calculators-toolbar", {
                attrs: {
                  "show-calculate": true,
                  "is-loading": _vm.isLoading,
                  "show-preview": false,
                },
                on: {
                  "set-default": _vm.handleCalc,
                  "clear-selection": _vm.handleClearSelection,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center",
              attrs: { cols: "12", sm: "12" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.rent_or_buy_description")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "3" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.monthly_payment_if_bought")) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t(
                      "financial-tools.monthly_payment_if_bought_description"
                    ),
                    expression:
                      "\n          $t('financial-tools.monthly_payment_if_bought_description')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-1",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "monthlyPayIfBought",
                  placeholder: "0",
                  "class-name": "fe-num-field dollar calculated",
                  autofocus: "",
                  "allow-minus": false,
                  label: _vm
                    .$t("financial-tools.monthly_payment_if_bought")
                    .toString(),
                  "show-tooltip-message": true,
                  max: "9999999999.99",
                  "max-length": 14,
                  "error-message": _vm.erMsgs.errorMonthlyPayIfBought.value,
                },
                on: {
                  change: function ($event) {
                    return _vm.resetResults()
                  },
                },
                model: {
                  value: _vm.indata.monthlyPayIfBought,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "monthlyPayIfBought", $$v)
                  },
                  expression: "indata.monthlyPayIfBought",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "3" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("application-form.down-payment")) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t("financial-tools.downpayment_description"),
                    expression:
                      "\n          $t('financial-tools.downpayment_description')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-1",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "downpayment",
                  placeholder: "0",
                  "class-name": "fe-num-field dollar calculated",
                  "allow-minus": false,
                  label: _vm.$t("application-form.down-payment").toString(),
                  "show-tooltip-message": true,
                  max: "9999999999.99",
                  "max-length": 14,
                  "error-message": _vm.erMsgs.errorDownpayment.value,
                },
                on: {
                  change: function ($event) {
                    return _vm.resetResults()
                  },
                },
                model: {
                  value: _vm.indata.downpayment,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "downpayment", $$v)
                  },
                  expression: "indata.downpayment",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "3" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.property_taxes")) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t(
                      "financial-tools.annual_property_taxes_description"
                    ),
                    expression:
                      "\n          $t('financial-tools.annual_property_taxes_description')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-1",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "propertytax",
                  "class-name": "fe-num-field dollar calculated",
                  "allow-minus": false,
                  label: _vm.$t("financial-tools.property_taxes").toString(),
                  "show-tooltip-message": true,
                  max: "9999999999.99",
                  "max-length": 14,
                  "error-message": _vm.erMsgs.errorPropertytax.value,
                },
                on: {
                  change: function ($event) {
                    return _vm.resetResults()
                  },
                },
                model: {
                  value: _vm.indata.propertytax,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "propertytax", $$v)
                  },
                  expression: "indata.propertytax",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "3" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.interest_rate")) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t("financial-tools.interest_rate_description"),
                    expression:
                      "\n          $t('financial-tools.interest_rate_description')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-1",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "interest_rate",
                  "class-name": "fe-num-field decimal-input calculated",
                  decimals: 3,
                  "allow-minus": false,
                  percentage: true,
                  label: _vm.$t("financial-tools.interest_rate").toString(),
                  "show-tooltip-message": true,
                  max: "100",
                  "max-length": 6,
                  "error-message": _vm.erMsgs.errorRate.value,
                },
                on: {
                  change: function ($event) {
                    return _vm.resetResults()
                  },
                },
                model: {
                  value: _vm.indata.interestrate,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "interestrate", $$v)
                  },
                  expression: "indata.interestrate",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "3" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("financial-tools.annual_increase_in_home_value")
                  ) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t(
                      "financial-tools.annual_increase_description"
                    ),
                    expression:
                      "\n          $t('financial-tools.annual_increase_description')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-1",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "annualIncreaseInHomePerc",
                  "class-name": "fe-num-field decimal-input calculated",
                  decimals: 3,
                  "allow-minus": false,
                  percentage: true,
                  label: _vm
                    .$t("financial-tools.annual_increase_in_home_value")
                    .toString(),
                  "show-tooltip-message": true,
                  max: "100",
                  "max-length": 6,
                  "error-message":
                    _vm.erMsgs.errorAnnualIncreaseInHomePerc.value,
                },
                on: {
                  change: function ($event) {
                    return _vm.resetResults()
                  },
                },
                model: {
                  value: _vm.indata.annualIncreaseInHomePerc,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "annualIncreaseInHomePerc", $$v)
                  },
                  expression: "indata.annualIncreaseInHomePerc",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "3" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("application-form.monthly-rent")) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t("financial-tools.monthly_rent_description"),
                    expression:
                      "\n          $t('financial-tools.monthly_rent_description')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-1",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "monthlyRent",
                  placeholder: "0",
                  "class-name": "fe-num-field dollar calculated",
                  "allow-minus": false,
                  label: _vm.$t("application-form.monthly-rent").toString(),
                  "show-tooltip-message": true,
                  max: "9999999999.99",
                  "max-length": 14,
                  "error-message": _vm.erMsgs.errorMonthlyRent.value,
                },
                on: {
                  change: function ($event) {
                    return _vm.resetResults()
                  },
                },
                model: {
                  value: _vm.indata.monthlyRent,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "monthlyRent", $$v)
                  },
                  expression: "indata.monthlyRent",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            {
              staticClass: "align-items-center pt-2",
              attrs: { cols: "12", sm: "3" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("financial-tools.years_of_comparison")) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.bottom.html",
                    value: _vm.$t(
                      "financial-tools.years_of_comparison_description"
                    ),
                    expression:
                      "\n          $t('financial-tools.years_of_comparison_description')\n        ",
                    modifiers: { bottom: true, html: true },
                  },
                ],
                staticClass: "ml-2 registered-tooltip",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "m-0 p-0 mr-0 pb-1",
              attrs: { cols: "12", sm: "2" },
            },
            [
              _c("text-section", {
                attrs: {
                  name: "yearsOfComparison",
                  placeholder: "0",
                  "class-name": "fe-num-field calculated",
                  "allow-minus": false,
                  label: _vm
                    .$t("financial-tools.years_of_comparison")
                    .toString(),
                  "show-tooltip-message": true,
                  max: "99.99",
                  "max-length": 6,
                  "error-message": _vm.erMsgs.errorYearsOfComparison.value,
                },
                on: {
                  change: function ($event) {
                    return _vm.resetResults()
                  },
                },
                model: {
                  value: _vm.indata.yearsOfComparison,
                  callback: function ($$v) {
                    _vm.$set(_vm.indata, "yearsOfComparison", $$v)
                  },
                  expression: "indata.yearsOfComparison",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-row", { staticClass: "ml-3 mt-4" }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("financial-tools.summary")))]),
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-1 pb-1" },
        [
          _c(
            "b-col",
            { staticClass: "align-items-center", attrs: { cols: "12" } },
            [_c("div", { domProps: { innerHTML: _vm._s(_vm.outdata) } })]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-row", { staticClass: "m-3" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("financial-tools.DHdisclaimer")) + "\n  "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }